import clsx from "clsx";
import React, { FC, useState } from "react";

import { Cta } from "../../../buttons/cta";
import { Icon } from "../../../icon";

export interface HeaderMenuItemTabProps {
  linksSection: Queries.HeaderMenuLinksSectionDataFragment;
  isSingleLinkSection: boolean;
}

export const HeaderMenuLinksSection: FC<HeaderMenuItemTabProps> = ({
  linksSection,
  isSingleLinkSection,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { ctas } = linksSection;

  return (
    <div className="flex flex-col gap-2">
      {!isSingleLinkSection && (
        <div
          className="flex items-center justify-between cursor-pointer pr-3"
          onClick={() => setIsOpen((isOpen) => !isOpen)}
        >
          {linksSection.title && <h5 className="text-lg">{linksSection?.title}</h5>}
          <Icon icon="chevron-up-thick" className={clsx(!isOpen && "rotate-180")} />
        </div>
      )}

      <div
        className={clsx(
          "transition-all duration-300 flex flex-col gap-3 overflow-hidden",
          isOpen || isSingleLinkSection ? "max-h-screen" : "max-h-0",
          !isSingleLinkSection && "pl-3"
        )}
      >
        {ctas?.map(
          (cta, i) =>
            cta?.label && (
              <Cta {...cta} key={i} className="font-light cursor-pointer">
                {cta.label}
              </Cta>
            )
        )}
      </div>
    </div>
  );
};
